import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function ProductDetail(props) {
  const appText = useI18n();
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);

  useEffect(() => {
    if (props.contractID) {
      setIsLoading(true);
      _loadProductDetails();
    }
  }, [props.contractID]);

  async function _loadProductDetails() {
    await NuxeoClient.instance()
      .fetchProductDetails(props.contractID)
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (productDetail) => {
    props.handleChange("productDetail", productDetail.label);
    props.handleChange("productDetailID", productDetail.id);
  };

  return (
    // <Tooltip arrow title="Please, select the appropriate product detail for this submission">
    <Tooltip arrow title={appText.T130}>
      <Grid item={true} xs={12}>
        <div id="productDetail">
          <InputLabel className="field-label field-dropdown" required>
            {/* {props.type === "publishing" ? "Format" : "Product Detail"} */}
            {props.type === "publishing" ? `${appText.T310}` : `${appText.T82}`}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"productDetail"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
